import { ReactNode } from 'react';
import styled from 'styled-components';

export const UIFlex = styled.div`
    flex-direction: column;
    display: flex;
    flex: 1;
`;

export const UIScrollWrapper = styled.div`
    position: relative;
    display: flex;
    flex: 1;
`;

export const UIScroll = styled.div`
    overflow: auto;
    position: absolute;
    inset: 0;
`;

// TODO: BETTER NAMING ?
export const WidgetScroll = ({
    header,
    scrollable,
    footer,
}: {
    header?: () => ReactNode;
    scrollable?: () => ReactNode;
    footer?: () => ReactNode;
}) => {
    return (
        <UIFlex>
            {header && header()}
            <UIScrollWrapper>
                <UIScroll>{scrollable && scrollable()}</UIScroll>
            </UIScrollWrapper>
            {footer && footer()}
        </UIFlex>
    );
};
